import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationModalComponent } from '../../../../shared/components/confirmation-modal/confirmation-modal.component';
import { FaqModel } from '../../../../shared/models/faq.model';
import { SharedModule } from '../../../../shared/shared.module';
import { AddEditTopicComponent } from '../add-edit-topic/add-edit-topic.component';
import { ActionMenuComponent } from '../../../../shared/components/action-menu/action-menu.component';

@Component({
  selector: 'app-topic-card',
  standalone: true,
  imports: [ConfirmationModalComponent, SharedModule, AddEditTopicComponent,ActionMenuComponent],
  templateUrl: './topic-card.component.html',
  styleUrl: './topic-card.component.scss',
})
export class TopicCardComponent {
  @Input() topic: FaqModel | null = null;
  @Output() onEdit: EventEmitter<void> = new EventEmitter<void>();
  @Output() onDelete: EventEmitter<string> = new EventEmitter<string>();
  @Output() onMenuOpen: EventEmitter<void> = new EventEmitter<void>();
  @Input() menuOpen: boolean = false;
  @Output() closeMenuEmitter: EventEmitter<void> = new EventEmitter();
  @Input() selectedTopicId: string = '';

  constructor() {}

  handleEditTopic() {
    this.onEdit.emit();
  }

  closeAllMenu() {
    this.closeMenuEmitter.emit();
  }

  openMenu() {
    this.onMenuOpen.emit();
  }

  handleDelete() {
    this.onDelete.emit(this.topic?.id);
  }
}
